import { Image, Spinner } from '@change/ds-core-ui';
import { cn } from '@change/ds-utils';

type HeaderImageProps = {
	imageUrl?: string;
	isImageProcessing: boolean;
	alt: string;
	imageClassName?: string;
	processingClassName?: string;
	testIdPrefix?: string;
};

export function HeaderImage({
	imageUrl,
	isImageProcessing,
	alt,
	imageClassName,
	processingClassName,
	testIdPrefix = 'header',
}: HeaderImageProps): JSX.Element | null {
	if (imageUrl) {
		return (
			<Image
				alt={alt}
				data-testid={`${testIdPrefix}-image`}
				data-qa={`${testIdPrefix}-image`}
				src={imageUrl}
				className={cn('flex aspect-square shrink-0 items-center justify-center object-cover', imageClassName)}
			/>
		);
	}

	if (isImageProcessing) {
		return (
			<div
				data-testid={`${testIdPrefix}-image-processing`}
				className={cn(
					'bg-background-secondary flex aspect-square shrink-0 items-center justify-center',
					processingClassName,
				)}
				aria-hidden="true"
			>
				<Spinner className="size-4" />
			</div>
		);
	}

	return null;
}
